import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'
import { TriviaTheme } from '../../../themeConstants'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    containerSection: {
        flexDirection: 'row',
        marginHorizontal: 12,
        marginVertical: 8,
    },
    section: {
        fontSize: 16,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
    },
    triviaItem: {
        flex: 1,
        paddingVertical: 6,
        paddingHorizontal: 15,
        flexDirection: 'row',
        alignContent: 'center',
        alignItems: 'center',
        textAlign: 'left',
    },
    benefitsModule: {
        flex: 1,
        padding: 10,
        flexDirection: 'row',
    },
    triviaImage: {
        width: 40,
        marginRight: 12,
        aspectRatio: 1,
        alignItems: 'center',
        borderRadius: 20,
    },
    triviaName: {
        fontSize: 15,
        marginBottom: 2,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
        textTransform: 'capitalize',
    },
    triviaDescription: {
        fontSize: 14,
        marginBottom: 2,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textTransform: 'capitalize',
    },
    justifyCenter: {
        justifyContent: 'center',
    },
    status: {
        fontSize: 12,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        textAlign: 'center',
        paddingHorizontal: 10,
        paddingVertical: 3,
        borderRadius: 5,
        overflow: 'hidden',
        alignItems: 'center',
    },
    points: {
        fontSize: 14,
        fontWeight: '600',
        color: theme.colors.textSecondary,
        textTransform: 'capitalize',
        textAlign: 'left',
    },
    dividerHorizontalLine: {
        flex: 1,
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,

        marginVertical: 10,
        marginHorizontal: 12,
    },
    image: {
        width: 140,
        height: 140,
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 6,
    },
    description: {
        fontSize: 17,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 23,
        paddingHorizontal: 40,
    },
    scrollView: {
        flexDirection: 'row',
        flexGrow: 0,
    },
    viewHeight: {
        height: 80,
    },
    spacer: {
        height: 84,
    },
    spacerBis: {
        marginTop: 175,
    },
    podium_avatar: {
        borderWidth: 2,
        borderColor: 'white',
    },
    podium_user_container: {},
    podium_user_points_container: {
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: TriviaTheme.podiumUserPointsTextcolor,
        backgroundColor: 'white',
        borderRadius: 12,
        alignContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 10,
        paddingVertical: 2,
    },
    podium_user_points_text: {
        fontWeight: 'bold',
        fontSize: 15,
        color: TriviaTheme.podiumUserPointsTextcolor,
    },
    podium_user_points_Pts: {
        fontSize: 15,
        color: TriviaTheme.podiumUserPointsTextcolor,
    },
    noRanking: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        borderRadius: 20,
        backgroundColor: theme.colors.lightGray,
        padding: 10,
        marginTop: 45,
    },
    containerNoRanking: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    imageNoRanking: {
        width: 160,
        height: 160,
        resizeMode: 'contain',
        marginVertical: 5,
        marginBottom: 5,
    },

    title2: {
        fontSize: 20,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginTop: 45,
    },
    description2: {
        fontSize: 17,
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 23,
        marginBottom: 1,
    },
    description3: {
        fontSize: 17,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 23,
        marginBottom: 1,
    },
    triviaPointsContainer: {
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: TriviaTheme.rankingPointsBorderColor,
        backgroundColor: 'white',
        borderRadius: 12,
        alignContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 12,
        paddingVertical: 7,
    },
    triviaPodiumContainer: {
        flexDirection: 'row',
        position: 'absolute',
    },
    triviaPodiumFirstPlacePosition: {
        flex: 1,
        top: '24%',
        left: '5%',
    },
    triviaPodiumFirstPlaceContainer: { alignSelf: 'flex-end', alignContent: 'center', alignItems: 'center', width: 100 },
    triviaPodiumSecondPlacePosition: { flex: 1, top: '1%' },
    triviaPodiumSecondPlaceContainer: { alignSelf: 'center', alignContent: 'center', alignItems: 'center', width: 100 },
    triviaPodiumThirdPlacePosition: { flex: 1, top: '35%', right: '5%' },
    triviaPodiumThirdPlaceContainer: { alignSelf: 'flex-start', alignContent: 'center', alignItems: 'center', width: 100 },
})

export default styles
